<template>
  <button v-if="url" class="flex items-center text-sm cursor-pointer text-lightblue-300 group">
    <a :href="url" target="_blank">
      <font-awesome-icon class="mr-1" icon="print" />
      <span class="text-left underline group-hover:no-underline">
        {{$t('toolbar.print')}}
      </span>
    </a>
  </button>
</template>

<script>

  export default {
    props: {
      url: {
        type: String,
        required: true,
      },
    },
  };

</script>
